// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Dark Theme Styles */
.dark-theme {
  color: #fff;
  transition: all 0.3s;
}

/* Card styles */
.dark-theme .ant-card {
  background-color: #1f1f1f;
  border-color: #303030;
  color: rgba(255, 255, 255, 0.85);
}

.dark-theme .ant-card-head {
  background-color: #262626;
  border-color: #303030;
  color: rgba(255, 255, 255, 0.85);
}

.dark-theme .ant-card-grid {
  background: #262626;
  border-color: #303030;
}

.dark-theme .ant-card-actions {
  background: #262626;
  border-color: #303030;
}

/* Table styles */
.dark-theme .ant-table {
  background-color: #1f1f1f;
  color: rgba(255, 255, 255, 0.85);
}

.dark-theme .ant-table-thead > tr > th {
  background-color: #262626;
  color: rgba(255, 255, 255, 0.85);
  border-bottom: 1px solid #303030;
}

.dark-theme .ant-table-tbody > tr > td {
  border-bottom: 1px solid #303030;
  color: rgba(255, 255, 255, 0.85);
}

.dark-theme .ant-table-tbody > tr:hover > td {
  background-color: #262626;
}

.dark-theme .ant-table-placeholder {
  background-color: #1f1f1f;
  border-color: #303030;
}

.dark-theme .ant-empty-description {
  color: rgba(255, 255, 255, 0.45);
}

/* List styles */
.dark-theme .ant-list {
  color: rgba(255, 255, 255, 0.85);
}

.dark-theme .ant-list-item {
  border-bottom-color: #303030;
  color: rgba(255, 255, 255, 0.85);
}

.dark-theme .ant-list-item-meta-description {
  color: rgba(255, 255, 255, 0.45);
}

/* Typography */
.dark-theme .ant-typography {
  color: rgba(255, 255, 255, 0.85);
}

.dark-theme h1.ant-typography,
.dark-theme h2.ant-typography,
.dark-theme h3.ant-typography,
.dark-theme h4.ant-typography {
  color: rgba(255, 255, 255, 0.85);
}

.dark-theme .ant-typography-secondary {
  color: rgba(255, 255, 255, 0.45);
}

/* Divider */
.dark-theme .ant-divider {
  background-color: #303030;
}

/* Inputs */
.dark-theme .ant-input {
  background-color: #141414;
  border-color: #303030;
  color: rgba(255, 255, 255, 0.85);
}

.dark-theme .ant-input-affix-wrapper {
  background-color: #141414;
  border-color: #303030;
  color: rgba(255, 255, 255, 0.85);
}

.dark-theme .ant-input-search-button {
  background-color: #1f1f1f;
  border-color: #303030;
}

/* Buttons */
.dark-theme .ant-btn {
  color: rgba(255, 255, 255, 0.85);
  background: #141414;
  border-color: #303030;
}

.ant-btn.btn-edit-light {
  background: var(--dark-danger) !important;
  border-color: var(--dark-danger)!important;
  color: var(--color-bg) !important;
}

.dark-theme .ant-btn.btn-edit-dark {
  background:var(--dark-danger) !important;
  border-color:var(--dark-danger) !important;
  color: var(--color-bg) !important;
}

.dark-theme .ant-btn.btn-edit-dark:hover,
.dark-theme .ant-btn.btn-edit-dark:focus {
  background: var(--color-red) !important;
  border-color: var(--color-red) !important;
}

.ant-btn.btn-cancel-light {
  background: var(--dark-danger) !important;
  border-color: var(--dark-danger)!important;
  color: var(--color-bg) !important;
}

.dark-theme .ant-btn.btn-cancel-dark {
  background:var(--dark-danger) !important;
  border-color:var(--dark-danger) !important;
  color: var(--color-bg) !important;
}

.dark-theme .ant-btn.btn-cancel-dark:hover,
.dark-theme .ant-btn.btn-cancel-dark:focus {
  background: var(--color-red) !important;
  border-color: var(--color-red) !important;
}

.ant-btn.btn-apply-light {
  background: var(--dark-success) !important;
  border-color: var(--dark-success)!important;
  color: #fff !important;
}

.dark-theme .ant-btn.btn-apply-dark {
  background:var(--dark-success) !important;
  border-color:var(--dark-success) !important;
  color: #fff !important;
}

.dark-theme .ant-btn.btn-apply-dark:hover,
.dark-theme .ant-btn.btn-apply-dark:focus {
  background: var(--color-green) !important;
  border-color: var(--color-green) !important;
}

.ant-btn.btn-filter-light {
  background: transparent !important;
  border-color: var(--color-theme)!important;
  color: var(--color-theme) !important;
}

.dark-theme .ant-btn.btn-filter-dark {
  background:var(--color-primary) !important;
  border-color:var(--color-primary) !important;
  color: var(--color-bg) !important;
}

.dark-theme .ant-btn.btn-filter-dark:hover,
.dark-theme .ant-btn.btn-filter-dark:focus {
  background: var(--color-theme) !important;
  border-color: var(--color-theme) !important;
}

.ant-btn.btn-get-light {
  background: transparent !important;
  border-color: var(--color-theme)!important;
  color: var(--color-theme) !important;
}

.dark-theme .ant-btn.btn-get-dark {
  background:var(--color-primary) !important;
  border-color:var(--color-primary) !important;
  color: var(--color-bg) !important;
}

.dark-theme .ant-btn.btn-get-dark:hover,
.dark-theme .ant-btn.btn-get-dark:focus {
  background: var(--color-dark-blue) !important;
  border-color: var(--color-dark-blue) !important;
}

.ant-btn.btn-excel-light {
  background: transparent !important;
  border-color: var(--color-theme)!important;
  color: var(--color-theme) !important;
}

.dark-theme .ant-btn.btn-excel-dark {
  background:var(--color-primary) !important;
  border-color:var(--color-primary) !important;
  color: var(--color-bg) !important;
}

.dark-theme .ant-btn.btn-excel-dark:hover,
.dark-theme .ant-btn.btn-excel-dark:focus {
  background: var(--color-theme) !important;
  border-color: var(--color-theme) !important;
}

.ant-btn.btn-pivot-light {
  background: transparent !important;
  border-color: var(--color-theme)!important;
  color: var(--color-theme) !important;
}

.dark-theme .ant-btn.btn-pivot-dark {
  background:var(--dark-warning) !important;
  border-color:var(--dark-warning) !important;
  color: var(--color-bg) !important;
}

.dark-theme .ant-btn.btn-pivot-dark:hover,
.dark-theme .ant-btn.btn-pivot-dark:focus {
  background: var(--color-orange) !important;
  border-color: var(--color-orange) !important;
}

.ant-btn.btn-save-light {
  background: var(--dark-success) !important;
  border-color: var(--dark-success)!important;
  color: #fff !important;
}

.dark-theme .ant-btn.btn-save-dark {
  background:var(--dark-success) !important;
  border-color:var(--dark-success) !important;
  color: #fff !important;
}

.dark-theme .ant-btn.btn-save-dark:hover,
.dark-theme .ant-btn.btn-save-dark:focus {
  background: var(--color-green) !important;
  border-color: var(--color-green) !important;
}

.ant-btn.btn-hover-light {
  border-color: var(--dark-purple)!important;
  color:  var(--dark-purple) !important;
}

.dark-theme .ant-btn.btn-hover-dark:hover,
.dark-theme .ant-btn.btn-hover-dark:focus {
  border-color: var(--color-purple) !important;
  color:  var(--color-purple) !important;
}

.dark-theme .ant-btn-text {
  color: rgba(255, 255, 255, 0.85);
  background: transparent;
  border-color: transparent;
}

.dark-theme .ant-btn-link {
  color: #1890ff;
  background: transparent;
  border-color: transparent;
}

.dark-theme .ant-layout-sider-trigger {
  color: #ffffff;
  background: #1890ff;
  border-color: transparent;
}

/* Dropdowns and Menus */
.dark-theme .ant-dropdown-menu {
  background-color: #1f1f1f;
  border: 1px solid #303030;
}

.ant-menu-inline{
  background-color: var(--color-theme)!important;
  border: 1px solid #303030;
}

.dark-theme .ant-menu-inline{
  background-color: var(--dark-bg)!important;
}

.dark-theme .ant-layout-sider-children-map{
  background-color: var(--dark-bg-secondary)!important;
}

.dark-theme .ant-dropdown-menu-item,
.dark-theme .ant-dropdown-menu-submenu-title {
  color: rgba(255, 255, 255, 0.85);
}

.dark-theme .ant-dropdown-menu-item:hover,
.dark-theme .ant-dropdown-menu-submenu-title:hover {
  background-color: #262626;
}

.dark-theme .ant-dropdown-menu-item-divider {
  background-color: #303030;
}

/* Select */
.dark-theme .ant-select-dropdown {
  background-color: #1f1f1f;
  border: 1px solid #303030;
}

.dark-theme .ant-select-item {
  color: rgba(255, 255, 255, 0.85);
}

.dark-theme .ant-select-item-option-selected {
  background-color: #111b26;
}

.dark-theme .ant-select-item-option-active {
  background-color: #262626;
}

/* Tooltips and Popovers */
.dark-theme .ant-tooltip-inner {
  background-color: #262626;
  color: rgba(255, 255, 255, 0.85);
}

.dark-theme .ant-popover-inner {
  background-color: #1f1f1f;
}

.dark-theme .ant-popover-title {
  border-color: #303030;
  color: rgba(255, 255, 255, 0.85);
}

.dark-theme .ant-popover-inner-content {
  color: rgba(255, 255, 255, 0.85);
}

/* Modal */
.dark-theme .ant-modal-content {
  background-color: #1f1f1f;
}

.dark-theme .ant-modal-header {
  background-color: #1f1f1f;
  border-color: #303030;
}

.dark-theme .ant-modal-title {
  color: rgba(255, 255, 255, 0.85);
}

.dark-theme .ant-modal-close {
  color: rgba(255, 255, 255, 0.45);
}

/* Menu */
.dark-theme .ant-menu-light {
  color: rgba(255, 255, 255, 0.85);
  background: #1f1f1f;
  border-right-color: #303030;
}

.dark-theme .ant-menu-item-selected {
  background-color: #111b26;
}

.dark-theme .ant-menu-submenu-selected {
  color: #1890ff;
}

/* Badge */
.dark-theme .ant-badge-count {
  background: #ff4d4f;
  color: #fff;
}

/* Checkbox */
.dark-theme .ant-checkbox-inner {
  background-color: #141414;
  border-color: #303030;
}

/* Radio */
.dark-theme .ant-radio-inner {
  background-color: #141414;
  border-color: #303030;
}

/* Switch */
.dark-theme .ant-switch {
  background-color: rgba(255, 255, 255, 0.25);
}

.App {
  text-align: center;
}

.logo {
  height: 32px;
  margin: 16px;
  background: rgba(255, 255, 255, 0.3);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
}

body[theme='dark'] {
  background-color: #141414;
  color: rgba(255, 255, 255, 0.85);
}

.site-layout .site-layout-background {
  background: #fff;
}

.ant-layout-sider-collapsed .logo span {
  display: none;
}

/* Custom styles for dashboard widgets */
.dashboard-card {
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0,0,0,0.07);
}

.dashboard-card .ant-card-head {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e8e8e8;
}

.dashboard-card .ant-card-body {
  padding: 12px 24px;
}

.user-info {
  display: flex;
  align-items: center;
}

.user-avatar {
  margin-right: 8px;
}

.activity-item {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.activity-item:last-child {
  border-bottom: none;
}

.activity-image {
  margin-top: 8px;
  max-width: 100%;
  border-radius: 4px;
}

/* Contract expired styling */
.contract-expired {
  color: #f44336 !important;
  font-weight: bold !important;
}

/* Dark theme support for expired contracts */
.dark-theme .contract-expired {
  color: #ff7875 !important;
  font-weight: bold !important;
}

/* ==========================================================================
   Responsive — küçük ekranlarda tablo taşması (5. Toplantı)
   Kırılım 768px: antd Sider'ın "md" kırılımı ve projede zaten kullanılan
   değer (HeaderComponent.jsx, FaturaPage.css, ik.css, Profil.css ...).
   ========================================================================== */

/* Flex çocuğun içeriğine göre şişip sayfayı yatayda taşırmasını engeller. */
.ant-layout,
.ant-layout-content {
  min-width: 0;
}

/* scroll.x verilmemiş tablolara da kaydırma kabı kazandırır. rc-table bu
   sarmalayıcıyı yalnızca scroll.x varken üretiyor; burada CSS ile tamamlanıyor.
   Not: !important KULLANILMAZ — sabit scroll={{x:700}} veren tablolarda
   rc-table table'a inline width yazar ve onun kazanması gerekir. */
.ant-table-wrapper .ant-table-content {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.ant-table-wrapper .ant-table-content > table {
  min-width: 100%;
}

/* Sabit başlıklı (scroll.y) tablolarda gövde/başlık AYRI <table> üretilir ve
   yatay kaydırmayı rc-table onScroll ile senkronlar. Başlığa bağımsız
   overflow-x VERİLMEZ: FixedHolder başlık div'ine inline overflow:hidden
   yazdığı için kural bugün etkisizdir, ama !important'la canlandırılırsa
   başlık kendi kaydırmasını kazanır ve gövdeyle senkronu kırılır. */
.ant-table-wrapper .ant-table-body {
  overflow-x: auto;
}

/* Yeniden kullanılabilir kap: tablo dışı geniş içerikler için. */
.responsive-table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Son emniyet: hiçbir şey sayfa gövdesini yatayda taşırmasın.
   \`clip\`, \`hidden\`in aksine position:sticky başlıkları bozmaz. */
html,
body {
  max-width: 100%;
  overflow-x: clip;
}

/* ===================================================================
   Mobil emniyet katmanı (13.08: tüm ekranlar responsive olmalı)
   =================================================================== */

/* scroll prop'u verilmemiş TÜM antd tabloları sayfayı taşırmak yerine
   kendi içinde yatay kaydırılır (MaliRapor, Personel, Profil, Sunum...). */
.ant-table-wrapper .ant-table-content,
.ant-table-wrapper .ant-table-body {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Dar tablolar konteyneri doldursun (FaturaPage.css'teki desenin globali). */
.ant-table-wrapper .ant-table-content > table {
  min-width: 100%;
  width: auto;
}

/* Ham <table> kullanan ekranlar için sarmalayıcı sınıf (JSX'te kullanılır):
   <div className="table-scroll"><table>...</table></div> */
.table-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
}

@media (max-width: 768px) {
  /* Dar ekranda hücre yoğunluğunu tek yerden azalt. */
  .ant-table-wrapper .ant-table-tbody > tr > td,
  .ant-table-wrapper .ant-table-thead > tr > th {
    padding: 6px 8px;
    font-size: 12px;
  }

  /* Sayfa kenar boşlukları dar ekranda yer kaybettiriyor. */
  .ant-layout-content {
    margin: 8px !important;
    padding: 8px !important;
  }

  /* Kart başlıklarındaki araç çubukları alt alta insin. */
  .ant-card-head-wrapper {
    flex-wrap: wrap;
    row-gap: 8px;
  }

  .ant-card-head-title,
  .ant-card-extra {
    width: 100%;
    max-width: 100%;
  }
}

/* ===================================================================
   Scrollbar görsel tutarlılığı (global)
   NOT: Bu blok kolon hizası sorununu ÇÖZMEZ. rc-table scrollbar genişliğini
   gerçek elemandan ölçer (getTargetScrollBarSize), dolayısıyla "antd'nin
   ölçtüğü pay yanlış" varsayımı hatalıydı. Blok yalnızca tarayıcılar arası
   tutarlı scrollbar görünümü için duruyor. Hiza sorununun gerçek sebebi
   table-layout:fixed + width:max-content birleşimidir; oraya bakın.
   antd (scroll.y) sabit-başlıklı tablolarda başlık ile gövde AYRI tablolardır;
   antd başlıkta gövdedeki dikey scrollbar kadar boş pay ayırır. Tarayıcı
   "overlay" (0 px) vs "klasik" scrollbar farkında bu pay gerçek scrollbar
   genişliğiyle uyuşmaz -> başlık ile veri kolonları KAYAR.
   Çözüm: tüm scrollbar'ları sabit genişlikte KLASİK yap. Böylece antd'nin
   ölçtüğü genişlik ile gövdenin gerçek scrollbar genişliği eşit olur ve
   başlık/gövde kolonları hizalanır. (Genel; antd'nin ölçüm elemanını da kapsar.)
   =================================================================== */
*::-webkit-scrollbar { width: 10px; height: 10px; }
*::-webkit-scrollbar-track { background: transparent; }
*::-webkit-scrollbar-thumb { background: rgba(0, 0, 0, 0.22); border-radius: 5px; }
*::-webkit-scrollbar-thumb:hover { background: rgba(0, 0, 0, 0.34); }
body.dark-theme *::-webkit-scrollbar-thumb,
body[data-theme='dark'] *::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.22); }
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE,gCAAgC;AAClC;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,YAAY;AACZ;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,gCAAgC;EAChC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;;EAEE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;;EAEE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;;EAEE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;;EAEE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;;EAEE,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;;EAEE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;;EAEE,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;;EAEE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;;EAEE,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,gCAAgC;EAChC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,aAAa;AACb;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;;;+EAI+E;;AAE/E,4EAA4E;AAC5E;;EAEE,YAAY;AACd;;AAEA;;;mEAGmE;AACnE;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;oEAIoE;AACpE;EACE,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;iEACiE;AACjE;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;wEAEwE;;AAExE;2EAC2E;AAC3E;;EAEE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,6EAA6E;AAC7E;EACE,eAAe;EACf,WAAW;AACb;;AAEA;2DAC2D;AAC3D;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,0DAA0D;EAC1D;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,wDAAwD;EACxD;IACE,eAAe;IACf,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;;;;;;;;;;;;;;wEAcwE;AACxE,uBAAuB,WAAW,EAAE,YAAY,EAAE;AAClD,6BAA6B,uBAAuB,EAAE;AACtD,6BAA6B,+BAA+B,EAAE,kBAAkB,EAAE;AAClF,mCAAmC,+BAA+B,EAAE;AACpE;qDACqD,qCAAqC,EAAE","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Dark Theme Styles */\n.dark-theme {\n  color: #fff;\n  transition: all 0.3s;\n}\n\n/* Card styles */\n.dark-theme .ant-card {\n  background-color: #1f1f1f;\n  border-color: #303030;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dark-theme .ant-card-head {\n  background-color: #262626;\n  border-color: #303030;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dark-theme .ant-card-grid {\n  background: #262626;\n  border-color: #303030;\n}\n\n.dark-theme .ant-card-actions {\n  background: #262626;\n  border-color: #303030;\n}\n\n/* Table styles */\n.dark-theme .ant-table {\n  background-color: #1f1f1f;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dark-theme .ant-table-thead > tr > th {\n  background-color: #262626;\n  color: rgba(255, 255, 255, 0.85);\n  border-bottom: 1px solid #303030;\n}\n\n.dark-theme .ant-table-tbody > tr > td {\n  border-bottom: 1px solid #303030;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dark-theme .ant-table-tbody > tr:hover > td {\n  background-color: #262626;\n}\n\n.dark-theme .ant-table-placeholder {\n  background-color: #1f1f1f;\n  border-color: #303030;\n}\n\n.dark-theme .ant-empty-description {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n/* List styles */\n.dark-theme .ant-list {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dark-theme .ant-list-item {\n  border-bottom-color: #303030;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dark-theme .ant-list-item-meta-description {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n/* Typography */\n.dark-theme .ant-typography {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dark-theme h1.ant-typography,\n.dark-theme h2.ant-typography,\n.dark-theme h3.ant-typography,\n.dark-theme h4.ant-typography {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dark-theme .ant-typography-secondary {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n/* Divider */\n.dark-theme .ant-divider {\n  background-color: #303030;\n}\n\n/* Inputs */\n.dark-theme .ant-input {\n  background-color: #141414;\n  border-color: #303030;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dark-theme .ant-input-affix-wrapper {\n  background-color: #141414;\n  border-color: #303030;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dark-theme .ant-input-search-button {\n  background-color: #1f1f1f;\n  border-color: #303030;\n}\n\n/* Buttons */\n.dark-theme .ant-btn {\n  color: rgba(255, 255, 255, 0.85);\n  background: #141414;\n  border-color: #303030;\n}\n\n.ant-btn.btn-edit-light {\n  background: var(--dark-danger) !important;\n  border-color: var(--dark-danger)!important;\n  color: var(--color-bg) !important;\n}\n\n.dark-theme .ant-btn.btn-edit-dark {\n  background:var(--dark-danger) !important;\n  border-color:var(--dark-danger) !important;\n  color: var(--color-bg) !important;\n}\n\n.dark-theme .ant-btn.btn-edit-dark:hover,\n.dark-theme .ant-btn.btn-edit-dark:focus {\n  background: var(--color-red) !important;\n  border-color: var(--color-red) !important;\n}\n\n.ant-btn.btn-cancel-light {\n  background: var(--dark-danger) !important;\n  border-color: var(--dark-danger)!important;\n  color: var(--color-bg) !important;\n}\n\n.dark-theme .ant-btn.btn-cancel-dark {\n  background:var(--dark-danger) !important;\n  border-color:var(--dark-danger) !important;\n  color: var(--color-bg) !important;\n}\n\n.dark-theme .ant-btn.btn-cancel-dark:hover,\n.dark-theme .ant-btn.btn-cancel-dark:focus {\n  background: var(--color-red) !important;\n  border-color: var(--color-red) !important;\n}\n\n.ant-btn.btn-apply-light {\n  background: var(--dark-success) !important;\n  border-color: var(--dark-success)!important;\n  color: #fff !important;\n}\n\n.dark-theme .ant-btn.btn-apply-dark {\n  background:var(--dark-success) !important;\n  border-color:var(--dark-success) !important;\n  color: #fff !important;\n}\n\n.dark-theme .ant-btn.btn-apply-dark:hover,\n.dark-theme .ant-btn.btn-apply-dark:focus {\n  background: var(--color-green) !important;\n  border-color: var(--color-green) !important;\n}\n\n.ant-btn.btn-filter-light {\n  background: transparent !important;\n  border-color: var(--color-theme)!important;\n  color: var(--color-theme) !important;\n}\n\n.dark-theme .ant-btn.btn-filter-dark {\n  background:var(--color-primary) !important;\n  border-color:var(--color-primary) !important;\n  color: var(--color-bg) !important;\n}\n\n.dark-theme .ant-btn.btn-filter-dark:hover,\n.dark-theme .ant-btn.btn-filter-dark:focus {\n  background: var(--color-theme) !important;\n  border-color: var(--color-theme) !important;\n}\n\n.ant-btn.btn-get-light {\n  background: transparent !important;\n  border-color: var(--color-theme)!important;\n  color: var(--color-theme) !important;\n}\n\n.dark-theme .ant-btn.btn-get-dark {\n  background:var(--color-primary) !important;\n  border-color:var(--color-primary) !important;\n  color: var(--color-bg) !important;\n}\n\n.dark-theme .ant-btn.btn-get-dark:hover,\n.dark-theme .ant-btn.btn-get-dark:focus {\n  background: var(--color-dark-blue) !important;\n  border-color: var(--color-dark-blue) !important;\n}\n\n.ant-btn.btn-excel-light {\n  background: transparent !important;\n  border-color: var(--color-theme)!important;\n  color: var(--color-theme) !important;\n}\n\n.dark-theme .ant-btn.btn-excel-dark {\n  background:var(--color-primary) !important;\n  border-color:var(--color-primary) !important;\n  color: var(--color-bg) !important;\n}\n\n.dark-theme .ant-btn.btn-excel-dark:hover,\n.dark-theme .ant-btn.btn-excel-dark:focus {\n  background: var(--color-theme) !important;\n  border-color: var(--color-theme) !important;\n}\n\n.ant-btn.btn-pivot-light {\n  background: transparent !important;\n  border-color: var(--color-theme)!important;\n  color: var(--color-theme) !important;\n}\n\n.dark-theme .ant-btn.btn-pivot-dark {\n  background:var(--dark-warning) !important;\n  border-color:var(--dark-warning) !important;\n  color: var(--color-bg) !important;\n}\n\n.dark-theme .ant-btn.btn-pivot-dark:hover,\n.dark-theme .ant-btn.btn-pivot-dark:focus {\n  background: var(--color-orange) !important;\n  border-color: var(--color-orange) !important;\n}\n\n.ant-btn.btn-save-light {\n  background: var(--dark-success) !important;\n  border-color: var(--dark-success)!important;\n  color: #fff !important;\n}\n\n.dark-theme .ant-btn.btn-save-dark {\n  background:var(--dark-success) !important;\n  border-color:var(--dark-success) !important;\n  color: #fff !important;\n}\n\n.dark-theme .ant-btn.btn-save-dark:hover,\n.dark-theme .ant-btn.btn-save-dark:focus {\n  background: var(--color-green) !important;\n  border-color: var(--color-green) !important;\n}\n\n.ant-btn.btn-hover-light {\n  border-color: var(--dark-purple)!important;\n  color:  var(--dark-purple) !important;\n}\n\n.dark-theme .ant-btn.btn-hover-dark:hover,\n.dark-theme .ant-btn.btn-hover-dark:focus {\n  border-color: var(--color-purple) !important;\n  color:  var(--color-purple) !important;\n}\n\n.dark-theme .ant-btn-text {\n  color: rgba(255, 255, 255, 0.85);\n  background: transparent;\n  border-color: transparent;\n}\n\n.dark-theme .ant-btn-link {\n  color: #1890ff;\n  background: transparent;\n  border-color: transparent;\n}\n\n.dark-theme .ant-layout-sider-trigger {\n  color: #ffffff;\n  background: #1890ff;\n  border-color: transparent;\n}\n\n/* Dropdowns and Menus */\n.dark-theme .ant-dropdown-menu {\n  background-color: #1f1f1f;\n  border: 1px solid #303030;\n}\n\n.ant-menu-inline{\n  background-color: var(--color-theme)!important;\n  border: 1px solid #303030;\n}\n\n.dark-theme .ant-menu-inline{\n  background-color: var(--dark-bg)!important;\n}\n\n.dark-theme .ant-layout-sider-children-map{\n  background-color: var(--dark-bg-secondary)!important;\n}\n\n.dark-theme .ant-dropdown-menu-item,\n.dark-theme .ant-dropdown-menu-submenu-title {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dark-theme .ant-dropdown-menu-item:hover,\n.dark-theme .ant-dropdown-menu-submenu-title:hover {\n  background-color: #262626;\n}\n\n.dark-theme .ant-dropdown-menu-item-divider {\n  background-color: #303030;\n}\n\n/* Select */\n.dark-theme .ant-select-dropdown {\n  background-color: #1f1f1f;\n  border: 1px solid #303030;\n}\n\n.dark-theme .ant-select-item {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dark-theme .ant-select-item-option-selected {\n  background-color: #111b26;\n}\n\n.dark-theme .ant-select-item-option-active {\n  background-color: #262626;\n}\n\n/* Tooltips and Popovers */\n.dark-theme .ant-tooltip-inner {\n  background-color: #262626;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dark-theme .ant-popover-inner {\n  background-color: #1f1f1f;\n}\n\n.dark-theme .ant-popover-title {\n  border-color: #303030;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dark-theme .ant-popover-inner-content {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n/* Modal */\n.dark-theme .ant-modal-content {\n  background-color: #1f1f1f;\n}\n\n.dark-theme .ant-modal-header {\n  background-color: #1f1f1f;\n  border-color: #303030;\n}\n\n.dark-theme .ant-modal-title {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.dark-theme .ant-modal-close {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n/* Menu */\n.dark-theme .ant-menu-light {\n  color: rgba(255, 255, 255, 0.85);\n  background: #1f1f1f;\n  border-right-color: #303030;\n}\n\n.dark-theme .ant-menu-item-selected {\n  background-color: #111b26;\n}\n\n.dark-theme .ant-menu-submenu-selected {\n  color: #1890ff;\n}\n\n/* Badge */\n.dark-theme .ant-badge-count {\n  background: #ff4d4f;\n  color: #fff;\n}\n\n/* Checkbox */\n.dark-theme .ant-checkbox-inner {\n  background-color: #141414;\n  border-color: #303030;\n}\n\n/* Radio */\n.dark-theme .ant-radio-inner {\n  background-color: #141414;\n  border-color: #303030;\n}\n\n/* Switch */\n.dark-theme .ant-switch {\n  background-color: rgba(255, 255, 255, 0.25);\n}\n\n.App {\n  text-align: center;\n}\n\n.logo {\n  height: 32px;\n  margin: 16px;\n  background: rgba(255, 255, 255, 0.3);\n  color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  font-size: 18px;\n}\n\nbody[theme='dark'] {\n  background-color: #141414;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.site-layout .site-layout-background {\n  background: #fff;\n}\n\n.ant-layout-sider-collapsed .logo span {\n  display: none;\n}\n\n/* Custom styles for dashboard widgets */\n.dashboard-card {\n  margin-bottom: 16px;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.07);\n}\n\n.dashboard-card .ant-card-head {\n  background-color: #f5f5f5;\n  border-bottom: 1px solid #e8e8e8;\n}\n\n.dashboard-card .ant-card-body {\n  padding: 12px 24px;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n}\n\n.user-avatar {\n  margin-right: 8px;\n}\n\n.activity-item {\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.activity-item:last-child {\n  border-bottom: none;\n}\n\n.activity-image {\n  margin-top: 8px;\n  max-width: 100%;\n  border-radius: 4px;\n}\n\n/* Contract expired styling */\n.contract-expired {\n  color: #f44336 !important;\n  font-weight: bold !important;\n}\n\n/* Dark theme support for expired contracts */\n.dark-theme .contract-expired {\n  color: #ff7875 !important;\n  font-weight: bold !important;\n}\n\n/* ==========================================================================\n   Responsive — küçük ekranlarda tablo taşması (5. Toplantı)\n   Kırılım 768px: antd Sider'ın \"md\" kırılımı ve projede zaten kullanılan\n   değer (HeaderComponent.jsx, FaturaPage.css, ik.css, Profil.css ...).\n   ========================================================================== */\n\n/* Flex çocuğun içeriğine göre şişip sayfayı yatayda taşırmasını engeller. */\n.ant-layout,\n.ant-layout-content {\n  min-width: 0;\n}\n\n/* scroll.x verilmemiş tablolara da kaydırma kabı kazandırır. rc-table bu\n   sarmalayıcıyı yalnızca scroll.x varken üretiyor; burada CSS ile tamamlanıyor.\n   Not: !important KULLANILMAZ — sabit scroll={{x:700}} veren tablolarda\n   rc-table table'a inline width yazar ve onun kazanması gerekir. */\n.ant-table-wrapper .ant-table-content {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.ant-table-wrapper .ant-table-content > table {\n  min-width: 100%;\n}\n\n/* Sabit başlıklı (scroll.y) tablolarda gövde/başlık AYRI <table> üretilir ve\n   yatay kaydırmayı rc-table onScroll ile senkronlar. Başlığa bağımsız\n   overflow-x VERİLMEZ: FixedHolder başlık div'ine inline overflow:hidden\n   yazdığı için kural bugün etkisizdir, ama !important'la canlandırılırsa\n   başlık kendi kaydırmasını kazanır ve gövdeyle senkronu kırılır. */\n.ant-table-wrapper .ant-table-body {\n  overflow-x: auto;\n}\n\n/* Yeniden kullanılabilir kap: tablo dışı geniş içerikler için. */\n.responsive-table-wrap {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Son emniyet: hiçbir şey sayfa gövdesini yatayda taşırmasın.\n   `clip`, `hidden`in aksine position:sticky başlıkları bozmaz. */\nhtml,\nbody {\n  max-width: 100%;\n  overflow-x: clip;\n}\n\n/* ===================================================================\n   Mobil emniyet katmanı (13.08: tüm ekranlar responsive olmalı)\n   =================================================================== */\n\n/* scroll prop'u verilmemiş TÜM antd tabloları sayfayı taşırmak yerine\n   kendi içinde yatay kaydırılır (MaliRapor, Personel, Profil, Sunum...). */\n.ant-table-wrapper .ant-table-content,\n.ant-table-wrapper .ant-table-body {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Dar tablolar konteyneri doldursun (FaturaPage.css'teki desenin globali). */\n.ant-table-wrapper .ant-table-content > table {\n  min-width: 100%;\n  width: auto;\n}\n\n/* Ham <table> kullanan ekranlar için sarmalayıcı sınıf (JSX'te kullanılır):\n   <div className=\"table-scroll\"><table>...</table></div> */\n.table-scroll {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  max-width: 100%;\n}\n\n@media (max-width: 768px) {\n  /* Dar ekranda hücre yoğunluğunu tek yerden azalt. */\n  .ant-table-wrapper .ant-table-tbody > tr > td,\n  .ant-table-wrapper .ant-table-thead > tr > th {\n    padding: 6px 8px;\n    font-size: 12px;\n  }\n\n  /* Sayfa kenar boşlukları dar ekranda yer kaybettiriyor. */\n  .ant-layout-content {\n    margin: 8px !important;\n    padding: 8px !important;\n  }\n\n  /* Kart başlıklarındaki araç çubukları alt alta insin. */\n  .ant-card-head-wrapper {\n    flex-wrap: wrap;\n    row-gap: 8px;\n  }\n\n  .ant-card-head-title,\n  .ant-card-extra {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n/* ===================================================================\n   Scrollbar görsel tutarlılığı (global)\n   NOT: Bu blok kolon hizası sorununu ÇÖZMEZ. rc-table scrollbar genişliğini\n   gerçek elemandan ölçer (getTargetScrollBarSize), dolayısıyla \"antd'nin\n   ölçtüğü pay yanlış\" varsayımı hatalıydı. Blok yalnızca tarayıcılar arası\n   tutarlı scrollbar görünümü için duruyor. Hiza sorununun gerçek sebebi\n   table-layout:fixed + width:max-content birleşimidir; oraya bakın.\n   antd (scroll.y) sabit-başlıklı tablolarda başlık ile gövde AYRI tablolardır;\n   antd başlıkta gövdedeki dikey scrollbar kadar boş pay ayırır. Tarayıcı\n   \"overlay\" (0 px) vs \"klasik\" scrollbar farkında bu pay gerçek scrollbar\n   genişliğiyle uyuşmaz -> başlık ile veri kolonları KAYAR.\n   Çözüm: tüm scrollbar'ları sabit genişlikte KLASİK yap. Böylece antd'nin\n   ölçtüğü genişlik ile gövdenin gerçek scrollbar genişliği eşit olur ve\n   başlık/gövde kolonları hizalanır. (Genel; antd'nin ölçüm elemanını da kapsar.)\n   =================================================================== */\n*::-webkit-scrollbar { width: 10px; height: 10px; }\n*::-webkit-scrollbar-track { background: transparent; }\n*::-webkit-scrollbar-thumb { background: rgba(0, 0, 0, 0.22); border-radius: 5px; }\n*::-webkit-scrollbar-thumb:hover { background: rgba(0, 0, 0, 0.34); }\nbody.dark-theme *::-webkit-scrollbar-thumb,\nbody[data-theme='dark'] *::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.22); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
